export const thirdPartyFund = [
    {
        "cif_key":6457123552,
        "id_number":611155402,
        "product_name":"GIRO - GIRO OVERDRAFT TDK HIT BBB PER",
        "balance":1449514018312.5200195312,
        "balance_2quarter":1417204064588.294921875,
        "account_status":"ACTIVE",
        "acct_open_date":"2019-11-04",
        "maturity_date":null,
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":7266342610,
        "id_number":5556566582,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":18229174.5599999987,
        "balance_2quarter":1792533969.0579349995,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-08-09",
        "maturity_date":null,
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":6457123552,
        "id_number":599451992,
        "product_name":"GIRO - GIRO ESCROW TDK HIT BBB PRSHN",
        "balance":72998.54,
        "balance_2quarter":72998.54,
        "account_status":"ACTIVE",
        "acct_open_date":"2019-09-02",
        "maturity_date":null,
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":7339932645,
        "id_number":3651444665,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":5098188.5999999996,
        "balance_2quarter":216644707.8218480945,
        "account_status":"ACTIVE",
        "acct_open_date":"2023-09-16",
        "maturity_date":null,
        "company_name":"PT SINARNIAGA SEJAHTERA",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":7266342610,
        "id_number":1399127182,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":14287067.9800000004,
        "balance_2quarter":113557975.4173908979,
        "account_status":"ACTIVE",
        "acct_open_date":"2023-10-14",
        "maturity_date":null,
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":6458751302,
        "id_number":989433780,
        "product_name":"DEPOSITO - DEPOSITO KAPITALISASI 12 IDR",
        "balance":1493410016.5799999237,
        "balance_2quarter":1485076194.555325985,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-06-26",
        "maturity_date":"2025-06-26",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":6458751302,
        "id_number":713682736,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":37174943.3999999985,
        "balance_2quarter":44213612.9919226021,
        "account_status":"ACTIVE",
        "acct_open_date":"2020-06-07",
        "maturity_date":null,
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":7266342610,
        "id_number":5555565863,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":29812531.3200000003,
        "balance_2quarter":97537989.2009778768,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-06-13",
        "maturity_date":null,
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":6563318744,
        "id_number":1722997277,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":2051634048810.3000488281,
        "balance_2quarter":1402868092881.4389648438,
        "account_status":"ACTIVE",
        "acct_open_date":"2011-03-13",
        "maturity_date":null,
        "company_name":"PUPUK INDONESIA PERSERO",
        "group_company":"PUPUK INDONESIA"
    },
    {
        "cif_key":7266342610,
        "id_number":5555656838,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":326436154165.9799804688,
        "balance_2quarter":558253890589.3853759766,
        "account_status":"ACTIVE",
        "acct_open_date":"2021-12-13",
        "maturity_date":null,
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":6441273160,
        "id_number":14255625,
        "product_name":"GIRO - GIRO HIT BUNGA BB PEMERINTAH",
        "balance":1376.78,
        "balance_2quarter":40298530.2593480796,
        "account_status":"ACTIVE",
        "acct_open_date":"2005-02-12",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":6458751302,
        "id_number":970660319,
        "product_name":"DEPOSITO - DEPOSITO KAPITALISASI 6 IDR",
        "balance":5155129962.1800003052,
        "balance_2quarter":5128748770.3972835541,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-04-26",
        "maturity_date":"2025-04-26",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":7266342610,
        "id_number":5555656830,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":55979228.0200000033,
        "balance_2quarter":3192604328.3274998665,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-04-25",
        "maturity_date":null,
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":6457123552,
        "id_number":798570240,
        "product_name":"GIRO - GIRO ESCROW TDK HIT BBB PRSHN",
        "balance":49851171.4799999967,
        "balance_2quarter":4665367796.4222831726,
        "account_status":"ACTIVE",
        "acct_open_date":"2020-11-22",
        "maturity_date":null,
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":6458751302,
        "id_number":989434445,
        "product_name":"DEPOSITO - DEPOSITO KAPITALISASI 12 IDR",
        "balance":1437592190.0999999046,
        "balance_2quarter":1429569852.3783700466,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-06-26",
        "maturity_date":"2025-06-26",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":6458751302,
        "id_number":713666865,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":58015562.3819800019,
        "balance_2quarter":648507763.8101284504,
        "account_status":"ACTIVE",
        "acct_open_date":"2020-06-07",
        "maturity_date":null,
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":6563318744,
        "id_number":1119408003,
        "product_name":"GIRO - GIRO OVERDRAFT TDK HIT BBB PER",
        "balance":74695165937.6000061035,
        "balance_2quarter":1441916644055.7570800781,
        "account_status":"ACTIVE",
        "acct_open_date":"2023-01-28",
        "maturity_date":null,
        "company_name":"PUPUK INDONESIA PERSERO",
        "group_company":"PUPUK INDONESIA"
    },
    {
        "cif_key":6449736805,
        "id_number":23531186,
        "product_name":"GIRO - GIRO TDK HIT BBB PEMERINTAH",
        "balance":0.0,
        "balance_2quarter":0.0,
        "account_status":"ACTIVE",
        "acct_open_date":"2005-04-17",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":7266342610,
        "id_number":4290472470,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":26331260321.5050010681,
        "balance_2quarter":60135189085.3391189575,
        "account_status":"ACTIVE",
        "acct_open_date":"2024-02-03",
        "maturity_date":null,
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":6441273160,
        "id_number":6348572068,
        "product_name":"GIRO - GIRO TDK HIT BBB PEMERINTAH",
        "balance":0.0,
        "balance_2quarter":0.0,
        "account_status":"ACTIVE",
        "acct_open_date":"2020-03-02",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":6458751302,
        "id_number":970620270,
        "product_name":"DEPOSITO - DEPOSITO KAPITALISASI 12 IDR",
        "balance":1390321733.5999999046,
        "balance_2quarter":1382563185.8297829628,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-04-26",
        "maturity_date":"2025-04-26",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":6458751302,
        "id_number":33340491,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":6688791800.6199998856,
        "balance_2quarter":5918744760.1691293716,
        "account_status":"ACTIVE",
        "acct_open_date":"1994-09-13",
        "maturity_date":null,
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":6457123552,
        "id_number":668729653,
        "product_name":"GIRO - GIRO OVDRAFT TDK HIT BBB PERS",
        "balance":619270875.5670000315,
        "balance_2quarter":607393184.8456038237,
        "account_status":"ACTIVE",
        "acct_open_date":"2020-05-22",
        "maturity_date":null,
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":6457123552,
        "id_number":693727228,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":11859095.2799999993,
        "balance_2quarter":1419312889.3520650864,
        "account_status":"ACTIVE",
        "acct_open_date":"2020-08-07",
        "maturity_date":null,
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":6441273160,
        "id_number":14255641,
        "product_name":"GIRO - GIRO HIT BUNGA BB PEMERINTAH",
        "balance":0.0,
        "balance_2quarter":644409435351.1240234375,
        "account_status":"ACTIVE",
        "acct_open_date":"2005-02-12",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":6441273160,
        "id_number":6348572238,
        "product_name":"GIRO - GIRO HIT BUNGA BB PEMERINTAH",
        "balance":444090619965.7680053711,
        "balance_2quarter":435448339905.3353881836,
        "account_status":"ACTIVE",
        "acct_open_date":"2013-07-19",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":6458751302,
        "id_number":970388880,
        "product_name":"DEPOSITO - DEPOSITO KAPITALISASI 12 IDR",
        "balance":2632512822.0399999619,
        "balance_2quarter":2617822351.5133700371,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-04-26",
        "maturity_date":"2025-04-26",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":6457123552,
        "id_number":31811642,
        "product_name":"GIRO - GIRO HIT BUNGA BB PEMERINTAH",
        "balance":8533204007.3400001526,
        "balance_2quarter":49478859817.9643478394,
        "account_status":"ACTIVE",
        "acct_open_date":"1977-07-06",
        "maturity_date":null,
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":6457123552,
        "id_number":606858225,
        "product_name":"GIRO - GIRO HIT BUNGA BB PEMERINTAH",
        "balance":38132395.3400000036,
        "balance_2quarter":382467067.5413038135,
        "account_status":"ACTIVE",
        "acct_open_date":"2019-10-14",
        "maturity_date":null,
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":7339284254,
        "id_number":5627754245,
        "product_name":"GIRO - GIRO TDK HIT BBB PERUSAHAAN",
        "balance":662848862.2000000477,
        "balance_2quarter":815855915.3661961555,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-06-13",
        "maturity_date":null,
        "company_name":"TUDUNG PUTRA PUTRI JAYA",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":7339932645,
        "id_number":3651444723,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":971721045.6000000238,
        "balance_2quarter":1519216212.8413040638,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-06-26",
        "maturity_date":null,
        "company_name":"PT SINARNIAGA SEJAHTERA",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":6441273160,
        "id_number":6364214488,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":23461102.0799999982,
        "balance_2quarter":16975351.3594899215,
        "account_status":"ACTIVE",
        "acct_open_date":"2024-11-03",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":6434415954,
        "id_number":6372848,
        "product_name":"GIRO - GIRO GA 123",
        "balance":5216322731.501999855,
        "balance_2quarter":97864817993.5855102539,
        "account_status":"ACTIVE",
        "acct_open_date":"1993-07-24",
        "maturity_date":null,
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS"
    },
    {
        "cif_key":6441273160,
        "id_number":6359500202,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":40712197063.7200012207,
        "balance_2quarter":301624675557.6099243164,
        "account_status":"ACTIVE",
        "acct_open_date":"2024-11-03",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":7339932645,
        "id_number":3651444738,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":23622716.7800000012,
        "balance_2quarter":2313879540.3253259659,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-06-26",
        "maturity_date":null,
        "company_name":"PT SINARNIAGA SEJAHTERA",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":7266342610,
        "id_number":5555209484,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":15076098.6999999993,
        "balance_2quarter":31849865.1186961606,
        "account_status":"ACTIVE",
        "acct_open_date":"2024-01-02",
        "maturity_date":null,
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":6441273160,
        "id_number":6362643062,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":17454722372950.369140625,
        "balance_2quarter":14089128014110.41015625,
        "account_status":"ACTIVE",
        "acct_open_date":"2024-11-03",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":6434415954,
        "id_number":6372838,
        "product_name":"GIRO - GIRO GA 500",
        "balance":544280712494.6799926758,
        "balance_2quarter":615240787791.6881103516,
        "account_status":"ACTIVE",
        "acct_open_date":"1992-09-07",
        "maturity_date":null,
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS"
    },
    {
        "cif_key":6458751302,
        "id_number":963228874,
        "product_name":"DEPOSITO - DEPOSITO KAPITALISASI 12 IDR",
        "balance":97561882.2199999988,
        "balance_2quarter":96947757.8098908663,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-04-09",
        "maturity_date":"2025-04-09",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":7392932473,
        "id_number":6357087976,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":41359405.6000000015,
        "balance_2quarter":58288138.2516297996,
        "account_status":"ACTIVE",
        "acct_open_date":"2023-04-04",
        "maturity_date":null,
        "company_name":"GARUDA TIMUR PACIFIC",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":6458751302,
        "id_number":970678488,
        "product_name":"DEPOSITO - DEPOSITO KAPITALISASI 6 IDR",
        "balance":1267201952.7799999714,
        "balance_2quarter":1260717094.4891300201,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-04-26",
        "maturity_date":"2025-04-26",
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":6441273160,
        "id_number":6348571678,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":44294788429.4430007935,
        "balance_2quarter":2935627090852.7641601562,
        "account_status":"ACTIVE",
        "acct_open_date":"2011-02-13",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":7339932645,
        "id_number":3651444892,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":6968436.9199999999,
        "balance_2quarter":64415314.7766297981,
        "account_status":"ACTIVE",
        "acct_open_date":"2022-11-25",
        "maturity_date":null,
        "company_name":"PT SINARNIAGA SEJAHTERA",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":6457123552,
        "id_number":1323655575,
        "product_name":"GIRO - GIRO TDK HIT BBB PERUSAHAAN",
        "balance":92592944.5,
        "balance_2quarter":92732109.875,
        "account_status":"ACTIVE",
        "acct_open_date":"2024-07-13",
        "maturity_date":null,
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":6445399958,
        "id_number":193362200,
        "product_name":"GIRO - GIRO HIT BUNGA BB PEMERINTAH",
        "balance":2019939.2,
        "balance_2quarter":2019939.2,
        "account_status":"ACTIVE",
        "acct_open_date":"2012-11-12",
        "maturity_date":null,
        "company_name":"PERUSAHAAN LISTRIK NEGARA, PT (PERSERO)",
        "group_company":"PLN GROUP"
    },
    {
        "cif_key":7266342610,
        "id_number":5557071465,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERORANGAN",
        "balance":3435184.3599999999,
        "balance_2quarter":140331035.1913037896,
        "account_status":"ACTIVE",
        "acct_open_date":"2023-12-19",
        "maturity_date":null,
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD"
    },
    {
        "cif_key":6457123552,
        "id_number":6357062927,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":369039789.3399999738,
        "balance_2quarter":295627231.7602167726,
        "account_status":"ACTIVE",
        "acct_open_date":"2019-01-01",
        "maturity_date":null,
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP"
    },
    {
        "cif_key":6441273160,
        "id_number":14255697,
        "product_name":"GIRO - GIRO HIT BUNGA BB PEMERINTAH",
        "balance":0.0,
        "balance_2quarter":0.0,
        "account_status":"ACTIVE",
        "acct_open_date":"1991-06-03",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":6441273160,
        "id_number":6348571654,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":90638780880.6522064209,
        "balance_2quarter":272713394947.2406005859,
        "account_status":"ACTIVE",
        "acct_open_date":"2011-02-13",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":6441273160,
        "id_number":14255609,
        "product_name":"GIRO - GIRO HIT BUNGA BB PEMERINTAH",
        "balance":0.0,
        "balance_2quarter":20445.99076106,
        "account_status":"ACTIVE",
        "acct_open_date":"1999-06-18",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":6434415954,
        "id_number":1298864569,
        "product_name":"GIRO - GIRO ESCROW TDK HIT B PRS USD",
        "balance":0.0,
        "balance_2quarter":9894613.5384730808,
        "account_status":"ACTIVE",
        "acct_open_date":"2024-03-16",
        "maturity_date":null,
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS"
    },
    {
        "cif_key":6441273160,
        "id_number":6361071635,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":2057516.6799999999,
        "balance_2quarter":1556437.11581008,
        "account_status":"ACTIVE",
        "acct_open_date":"2024-11-03",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":6441273160,
        "id_number":48437270,
        "product_name":"GIRO - GIRO HIT BUNGA BB PERUSAHAAN",
        "balance":51255908434.9049987793,
        "balance_2quarter":8381865989213.5068359375,
        "account_status":"ACTIVE",
        "acct_open_date":"2005-08-05",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    },
    {
        "cif_key":6441273160,
        "id_number":6348571881,
        "product_name":"GIRO - GIRO TDK HIT BBB PEMERINTAH",
        "balance":940147414.1000000238,
        "balance_2quarter":20421775222.5473899841,
        "account_status":"ACTIVE",
        "acct_open_date":"2018-08-07",
        "maturity_date":null,
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP"
    }
]
